module.exports = __webpack_public_path__ + "img/6.8a39ba02.png";